const checkoutConstants = {
  // Actions
  CHECKOUT_DELIVERY_METHOD_STARTED: "CHECKOUT_DELIVERY_METHOD_STARTED",
  CHECKOUT_DELIVERY_METHOD_GET_SUCCESS: "CHECKOUT_DELIVERY_METHOD_GET_SUCCESS",
  CHECKOUT_DELIVERY_METHOD_SUBMIT_SUCCESS:
    "CHECKOUT_DELIVERY_METHOD_SUBMIT_SUCCESS",
  CHECKOUT_PAYMENT_TOKEN_SUCCESS: "CHECKOUT_PAYMENT_TOKEN_SUCCESS",
  CHECKOUT_PLACE_ORDER_STARTED: "CHECKOUT_PLACE_ORDER_STARTED",
  CHECKOUT_PLACE_ORDER_FAILED: "CHECKOUT_PLACE_ORDER_FAILED",
  CHECKOUT_PLACE_ORDER_FAILED_RESET: "CHECKOUT_PLACE_ORDER_FAILED_RESET",
  CHECKOUT_SET_SHIPPING_RESTRICTION_FLAG:
    "CHECKOUT_SET_SHIPPING_RESTRICTION_FLAG",
  CHECKOUT_PACKAGING_SELECTION: "CHECKOUT_PACKAGING_SELECTION",

  // Sections on Page
  CHECKOUT_LOGIN_SECTION: "CHECKOUT_LOGIN_SECTION",
  CHECKOUT_SHIPPING_SECTION: "CHECKOUT_SHIPPING_SECTION",
  CHECKOUT_PAYMENT_SECTION: "CHECKOUT_PAYMENT_SECTION",

  CHECKOUT_SECTION_EXPANDED: "CHECKOUT_SECTION_EXPANDED",
  CHECKOUT_RESET_DATA: "CHECKOUT_RESET_DATA",

  STATUS_UNTOUCHED: "STATUS_UNTOUCHED",
  STATUS_COLLAPSED: "STATUS_COLLAPSED",
  STATUS_EXPANDED: "STATUS_EXPANDED",

  EPS_FAILED: "EPS_FAILED",
}

export default checkoutConstants
